import type { Provider } from '@angular/core';
import { InjectionToken } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';

export const ViewBaseRoute = new InjectionToken<string>('view base route');

export const provideViewBaseRoute = (baseRoute: string): Provider => ({
  provide: ViewBaseRoute,
  useValue: baseRoute,
});

export const { provide: provideViewDataScope, inject: injectViewDataScope } =
  createProviderToken<string>('view data scope')(false, {
    factory: () => 'default',
  });
